import React from 'react';
import Responsive from '@active/react-utils/components/Responsive';
import GridItem from '@active/react-ui/GridItem/GridItem';
import FormGroup from '@active/react-ui/FormGroup';
import FormLabel from '@active/react-ui/FormLabel';
import FormField from '@active/react-ui/FormField';
import Locale from '@active/react-utils/i18n/Locale';
import MenuItemsList from '../AddressEditor/components/MenuItemsList';

const TwoColsField = ({
  field, name, fieldConfig = {}, isTwoColsField = true,
}) => {
  const {
    name: fieldName,
    label,
    required: fieldRequired,
    component,
    data,
    ...fieldProps
  } = field;

  return (
    <GridItem className="cui-mg-t-20" spanMd={isTwoColsField ? 6 : 12} key={fieldName}>
      <FormGroup name={name ? `${name}.${fieldName}` : fieldName} required={fieldRequired} withoutLayout>
        <Responsive not eqAbove="md">
          <FormLabel htmlFor={fieldName}>
            <Locale id={label}/>
          </FormLabel>
        </Responsive>
        <Responsive eqAbove="md">
          <FormLabel htmlFor={fieldName} truncate>
            <Locale id={label}/>
          </FormLabel>
        </Responsive>
        <FormField id={fieldName} as={component} {...fieldProps} {...fieldConfig} >
          {data && MenuItemsList({ data })}
        </FormField>
      </FormGroup>
    </GridItem>
  );
};

export default TwoColsField;
